import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { SealCheck, XCircle, ShieldWarning } from "@phosphor-icons/react";

export default function VerifyPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get(`/verify/${id}`).then((r) => setData(r.data)).catch(() => setData({ found: false })).finally(() => setLoading(false)); }, [id]);

  return (
    <div className="min-h-screen bg-zinc-100 grid place-items-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-6 justify-center">
          <div className="h-9 w-9 grid place-items-center bg-zinc-950 text-white rounded-sm font-heading font-bold">L</div>
          <div className="text-[11px] uppercase tracking-widest text-zinc-500">Certificate Verification</div>
        </div>
        <div className="bg-white border border-zinc-200 rounded-sm p-8">
          {loading ? (
            <div className="flex justify-center py-8"><div className="h-8 w-8 border-2 border-zinc-200 border-t-zinc-900 rounded-full animate-spin" /></div>
          ) : !data?.found ? (
            <div data-testid="verify-notfound" className="text-center"><XCircle size={44} className="text-red-500 mx-auto mb-3" /><h1 className="font-heading text-xl text-zinc-900">Certificate not found</h1><p className="text-sm text-zinc-500 mt-1">No record matches this ID.</p></div>
          ) : (
            <div data-testid="verify-result">
              <div className="text-center mb-6">
                {data.valid ? <SealCheck size={48} weight="duotone" className="text-emerald-500 mx-auto mb-2" /> : <ShieldWarning size={48} weight="duotone" className="text-red-500 mx-auto mb-2" />}
                <h1 className="font-heading text-2xl tracking-tight text-zinc-900">{data.valid ? "Valid Certificate" : data.status}</h1>
              </div>
              <dl className="space-y-3 text-sm">
                <Row k="Certificate ID" v={data.certificate_id} mono />
                <Row k="Partner Name" v={data.partner_name} />
                <Row k="Brand" v={data.brand_name || "—"} />
                <Row k="Issue Date" v={fmtDate(data.issue_date)} />
                <Row k="Agreement" v={data.agreement_status} />
                <Row k="Status" v={data.status} />
              </dl>
              <p className="text-[11px] text-zinc-400 mt-6 text-center">Only non-sensitive information is shown. No KYC, bank or identity data is exposed.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const Row = ({ k, v, mono }) => (
  <div className="flex items-center justify-between border-b border-zinc-100 pb-2">
    <dt className="text-zinc-500">{k}</dt>
    <dd className={`text-zinc-900 ${mono ? "font-mono text-xs" : ""}`}>{v}</dd>
  </div>
);
